import Axios from '../axios'

export function getTimezoneId(latLng) {
  return Axios.get('/api/v1/timezones', {
    params: {
      lat: latLng.lat,
      lng: latLng.lng,
    },
  }).then((res) => res.data.timeZoneId)
}
